import * as actions from './dataTableReducer';
import request from 'axios';
import { debounce, get } from 'lodash';

const fetchDebounced = debounce((dispatch, name) => dispatch(fetchData(name)), 400);
let controller = new AbortController();
export function clearData(name) {
  return {
    type: actions.CLEAR_DATA,
    table: name,
  };
}

export function initTable(name, source, perPage = 10) {
  return {
    type: actions.INIT_TABLE,
    table: name,
    perPage,
    source,
  };
}

export function setSource(name, source) {
  return {
    type: actions.SET_SOURCE,
    table: name,
    source,
  };
}

export function setData(name, data, source, currentPage = 1) {
  return {
    type: actions.SET_DATA,
    table: name,
    currentPage,
    source,
    data,
  };
}

export function setPreloadedData(name, data, source = '', currentPage = 1) {
  return {
    type: actions.SET_DATA,
    table: name,
    currentPage,
    source,
    data,
  };
}

export function applyFilter(name, type, value) {
  return (dispatch, getState) => {
    const state = getState().dataTables;
    if (getFilter(state, name, type) !== value) {
      dispatch(setFilters(name, type, value));

      const offsetFilter = 'page[offset]';
      if (type !== offsetFilter && getFilter(state, name, offsetFilter)) {
        dispatch(setFilters(name, offsetFilter, 0));
      }
      fetchDebounced(dispatch, name);
    }
  };
}

export function applyFilters(name, filters, clear = false) {
  return (dispatch, getState) => {
    if (clear) {
      dispatch(clearFilters(name));
    }

    filters.map((filter) => {
      const state = getState().dataTables;
      const offsetFilter = 'page[offset]';
      if (filter.type !== offsetFilter && getFilter(state, name, offsetFilter)) {
        dispatch(setFilters(name, offsetFilter, 0));
      } else if (filter.value) {
        dispatch(setFilters(name, filter.type, filter.value));
      }
    });

    fetchDebounced(dispatch, name);
  };
}

export function getFilter(state, name, type) {
  const filter =
    state.tables[name] && state.tables[name].filters[type]
      ? state.tables[name].filters[type]
      : '';
  return filter ? filter : '';
}

export function refreshData(name) {
  return (dispatch) => {
    fetchDebounced(dispatch, name);
  };
}

export function clearFilters(name) {
  return {
    type: actions.CLEAR_FILTERS,
    table: name,
  };
}

export function setFilters(name, type, value) {
  if (value === false) {
    value = 'false';
  }

  if (value === true) {
    value = 'true';
  }

  return {
    type: actions.SET_FILTERS,
    table: name,
    filterType: type,
    value,
  };
}

function beginFetch(name, signal) {
  return {
    type: actions.FETCH_DATA,
    table: name,
    signal: signal,
  };
}

function isFetching(name, status) {
  return {
    type: actions.SET_IS_FETCHING,
    table: name,
    status: status,
  };
}
// function fetchError(name) {
//   return {
//     type: actions.FETCH_DATA_ERROR,
//     table: name,
//   }
// }

export function fetchData(name, customFilter) {
  return (dispatch, getState) => {
    const state = getState();
    const exisingSignal = state.dataTables.signal;
    if (exisingSignal && !exisingSignal.aborted) {
      controller.abort();
      controller = new AbortController();
    }
    const signal = controller.signal;
    let currentPage = 1;
    dispatch(beginFetch(name, controller.signal));
    dispatch(clearData(name));

    let dataTable = state.dataTables.tables[name];
    const source = dataTable.source;

    if (!source) {
      return;
    }

    let url = source;

    // add filters to the source url
    if (dataTable.filters) {
      let keys = Object.keys(dataTable.filters);

      if (keys.length) {
        keys.forEach((key, index) => {
          if (!index) {
            url += '?';
          }

          if (dataTable.filters[key] !== 0) {
            if (index) {
              url += '&';
            }
            url += key + '=' + dataTable.filters[key];
          }
        });
      }
    }

    if (dataTable.filters['page[offset]'] && dataTable.filters['page[limit]']) {
      currentPage +=
        parseInt(dataTable.filters['page[offset]']) /
        parseInt(dataTable.filters['page[limit]']);
    }

    if (url) {
      const filter = customFilter ? customFilter : '';
      const endpoint = `${url}${filter}`;

      return request
        .get(endpoint, {
          signal: signal,
        })
        .then((response) => {
          let results = response.data.data;
          results.forEach((key, index) => {
            if (get(key, 'attributes.name', '') === 'Policy Renewal') {
              results.splice(index, 1);
            }
          });

          return dispatch(setData(name, response.data, source, currentPage));
        });
    }
  };
}

export const setDataOnly = (name, data, included, total) => {
  return {
    type: actions.SET_DATA_ONLY,
    table: name,
    data: data,
    included: included,
    total: total,
  };
};

export const updateDataTable = (name, newData, newIncluded, isNew) => {
  return (dispatch, state) => {
    const existing = state().dataTables?.tables?.[name] ?? {};
    const { data, total, included } = existing;
    if (isNew) {
      data?.unshift(newData);
      dispatch(
        setDataOnly(
          name,
          data,
          included ? included.concat(newIncluded) : newIncluded,
          total ? total + 1 : 1,
        ),
      );
    } else {
      const updatedExisting = data?.map((existingItem) => {
        if (existingItem.id === newData.id) {
          return newData;
        }
        return existingItem;
      });

      dispatch(
        setDataOnly(
          name,
          updatedExisting,
          included ? included.concat(newIncluded) : newIncluded,
          total,
        ),
      );
    }
  };
};

export function dataOnly(name, url) {
  return (dispatch, state) => {
    const existing = state().dataTables?.tables?.[name] ?? {};
    const { data } = existing;
    dispatch(isFetching(name, true));

    return request
      .get(url)
      .then((response) => {
        const newData = data ? [...data, ...response?.data?.data] : response.data?.data;
        dispatch(
          setDataOnly(
            name,
            newData,
            response?.data?.included,
            response?.data?.meta?.total,
          ),
        );
        return response.data;
      })
      .finally(() => {
        dispatch(isFetching(name, false));
      });
  };
}
